import './App.css';
import TwitchMain from './Component/TwitchMain'

function App() {
  
  return (
    <div className="App">
      
        <TwitchMain />
    </div>
  );
}

export default App;
